"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Icons_1 = require("../../Atoms/Icons");
const S = __importStar(require("./Accordion.styles"));
exports.default = (props) => {
    const { titleText, subtext, children, collapse = false, onExpand } = props;
    const [collapseAccordion, setCollapse] = react_1.useState(collapse);
    const onPressAccordion = (data) => {
        setCollapse(!collapseAccordion);
        if (!collapseAccordion && onExpand) {
            onExpand(data);
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(S.Accordion, { testID: "Accordion", accessibilityLabel: titleText, accessibilityHint: "Tap to read content", accessibilityRole: "button", onPress: () => onPressAccordion(titleText) },
            react_1.default.createElement(S.InnerContainer, null,
                react_1.default.createElement(S.LeftImageView, null, !collapseAccordion ? (react_1.default.createElement(Icons_1.PlusIcon, { color: "black" })) : (react_1.default.createElement(Icons_1.UpArrow, { color: "black" }))),
                react_1.default.createElement(S.TextContainer, null,
                    react_1.default.createElement(S.TablerowText, { ellipsizeMode: "tail" }, titleText),
                    subtext && (react_1.default.createElement(S.TablerowSubText, { ellipsizeMode: "tail" }, subtext))))),
        collapseAccordion && (react_1.default.createElement(S.MoreInfoExpandedWrapper, { testID: "AccordionChildren" }, children))));
};
